var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "general-attribute-picker" },
    [
      !_vm.filterAttributes().length
        ? _c(
            "div",
            {
              staticClass:
                "d-flex flex-column justify-content-center text-center align-items-center mb-5",
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.$t("chatbotv2.noResultFound")))]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.getAttributeGroups(), function (attributeGroup) {
        return _c(
          "div",
          { staticClass: "attr-select" },
          [
            _c(
              "div",
              {
                staticClass: "tpl-category-select-category-name",
                attrs: {
                  "text-color": "lighter",
                  "text-weight": "semi-bold",
                  "text-type": "h5",
                },
              },
              [
                _vm._v(
                  "\n            " + _vm._s(attributeGroup.label) + "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.filterAttributes(attributeGroup.type), function (attr) {
              return _c(
                "div",
                {
                  staticClass: "picker-item",
                  class: { active: _vm.defaultSelected === attr.name },
                  attrs: {
                    "data-checked": "true",
                    "data-index": "0",
                    "data-item-label": "Name",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.pick(attr.value)
                    },
                  },
                },
                [
                  attributeGroup.icon === "material-icons"
                    ? [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v(" " + _vm._s(attributeGroup.iconValue) + " "),
                        ]),
                      ]
                    : attributeGroup.icon === "component"
                    ? [
                        _c("AttributeIconPreview", {
                          attrs: { attribute: attr.value },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "name" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.isLocalizedAttribute(attr.name)
                            ? _vm.$t("chatbotv2.attr." + attr.name)
                            : attr.name
                        ) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "description" }, [
                    _vm._v(" " + _vm._s(attr.placeholder) + " "),
                  ]),
                ],
                2
              )
            }),
          ],
          2
        )
      }),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("AddCustomAttribute", { attrs: { "on-added": _vm.pick } }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "material-icons" }, [_vm._v(" search ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }